<template>
  <base-overlay :show="fetching">
    <StickyDriverData />
    <DeleteLicenseModal
      :license="DeleteLicense"
      :dlicenses="Dlicenses"
    />
    <b-card>
      <div class="d-flex justify-content-between">
        <h2>Licenses</h2>
        <b-button
          v-if="canAddLicense"
          variant="outline-primary"
          @click="createLicenseHandler"
        >
          Create new license
        </b-button>
      </div>
      <template v-if="formVisible">
        <validation-observer ref="addLicenseRef">
          <b-row>
            <b-col md="3">
              <validation-provider
                #default="{ errors }"
                name="Start Date"
                rules="required"
              >
                <b-form-group label="Start Date">
                  <b-form-datepicker
                    v-model="licenseData.effective_date"
                    class="dateField"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <validation-provider
                #default="{ errors }"
                name="Expiry Date"
                rules="required"
              >
                <b-form-group label="Expiry Date">
                  <b-form-datepicker
                    v-model="licenseData.expiry_date"
                    class="ellipsis-input dateField"
                    :min="expiryDateMinimum"
                    :max="expiryDateMaximum"
                    :disabled="!licenseData.effective_date"
                    dropup
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <validation-provider
                #default="{ errors }"
                name="Reference Number"
                rules="required|max:10"
              >
                <b-form-group label="Reference Number">
                  <b-row>
                    <b-col>
                      <v-select
                        id="states"
                        v-model="createprefixNumber"
                        :options="prefixNumber"
                      />
                    </b-col>
                    <b-col>
                      <b-form-input
                        v-model="createsuffixNumber"
                        maxlength="5"
                      />
                    </b-col>
                  </b-row>
                  <span class="text-danger">{{ errors[0] }}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <b-form-group label="License Image">
                <b-form-file v-model="file" />
              </b-form-group>
            </b-col>
            <b-col
              md="3"
            >
              <b-button
                variant="primary"
                :disabled="submitting"
                @click="addLicenseHandler"
              >
                <b-spinner
                  v-if="submitting"
                  small
                />
                <span v-else>Add license</span>
              </b-button>
            </b-col>
          </b-row>
        </validation-observer>
        <hr>
      </template>
      <validation-observer
        v-if="editLicense.id"
        ref="editLicenseRef"
      >
        <b-row>
          <b-col md="3">
            <validation-provider
              #default="{ errors }"
              name="Start Date"
              rules="required"
            >
              <b-form-group label="Start Date">
                <b-form-datepicker
                  v-model="editLicense.effective_date"
                  :disabled="!editLicense.openEdit"
                  no-flip
                  class="dateField"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="3">
            <validation-provider
              #default="{ errors }"
              name="Expiry Date"
              rules="required"
            >
              <b-form-group label="Expiry Date">
                <b-form-datepicker
                  v-model="editLicense.expiry_date"
                  no-flip
                  :min="validateExpiryMin"
                  :max="validateExpiryMax"
                  :disabled="!editLicense.effective_date || !editLicense.openEdit"
                  class="dateField"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="3">
            <validation-provider
              #default="{ errors }"
              name="Reference Number"
              rules="required|max:10"
            >
              <b-form-group label="Reference Number">
                <b-row>
                  <b-col>
                    <v-select
                      id="states"
                      v-model="referenceNumber"
                      label="label"
                      placeholder="No state selected"
                      :options="prefixNumber"
                      :disabled="!editLicense.openEdit"
                    />
                  </b-col>
                  <b-col>
                    <b-form-input
                      v-model="editLicense.reference_number"
                      :disabled="!editLicense.openEdit"
                      maxlength="5"
                    />
                  </b-col>
                </b-row>
                <span class="text-danger">{{ errors[0] }}</span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            v-if="licenses"
            md="1"
            class="mt-1"
          >
            <validation-provider>
              <b-form-group>
                <b-button
                  :disabled="!editLicense.id"
                  style="height:40px;margin-top:12px"
                  variant="flat-primary"
                  size="sm"
                  @click="openDeleteLicenseModal(editLicense)"
                >
                  <template>
                    <!-- <span>Save</span> -->
                    <feather-icon
                      size="20"
                      icon="XIcon"
                      color="red"
                    />
                  </template>
                </b-button>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            v-if="editLicense.key"
            md="2"
            class="d-flex align-items-center"
          >
            <b-form-group
              v-if="editLicense.openEdit"
              label="License Image"
            >
              <b-form-file v-model="file" />
            </b-form-group>
            <b-form-group
              v-else
              label="License Attachment"
            >
              <div
                style="cursor:pointer"
                @click="openAttachment(editLicense.key)"
              >
                <b-avatar
                  :src="editLicense.key"
                />
              </div>
            </b-form-group>
            <b-button
              style="height:40px;margin-top:12px"
              variant="flat-primary"
              size="sm"
              :disabled="editLicense.editing"
              @click="handleLicenseEdit(editLicense)"
            >
              <b-spinner
                v-if="editLicense.editing"
                small
              />
              <template v-else>
                <span v-if="editLicense.openEdit">Save</span>
                <feather-icon
                  v-else
                  size="20"
                  icon="EditIcon"
                />
              </template>
            </b-button>
          </b-col>
          <b-col md="12">
            <hr>
          </b-col>
        </b-row>
      </validation-observer>
      <b-row
        v-for="(license) in licenses"
        :key="license.id"
      >
        <b-col
          v-if="license"
          md="3"
        >
          <b-form-group label="Start Date">
            <b-form-datepicker
              v-model="license.effective_date"
              :disabled="!license.openEdit"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Expiry Date">
            <b-form-datepicker
              v-model="license.expiry_date"
              :disabled="!license.openEdit"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Reference Number">
            <b-form-input
              v-model="license.reference_number"
              :disabled="!license.openEdit"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="licenses"
          md="1"
          class="mt-1"
        >
          <validation-provider>
            <b-form-group>
              <b-button
                :disabled="!editLicense.id"
                style="height:40px;margin-top:12px"
                variant="flat-primary"
                size="sm"
                @click="openDeleteLicenseModal(license)"
              >
                <template>
                  <!-- <span>Save</span> -->
                  <feather-icon
                    size="20"
                    icon="XIcon"
                    color="red"
                  />
                </template>
              </b-button>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          v-if="license.key"
          md="2"
          class="d-flex align-items-center"
        >
          <b-form-group
            label="License Attachment"
          >
            <div
              style="cursor:pointer"
              @click="openAttachment(license.key)"
            >
              <b-avatar
                :src="license.key"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <hr>
        </b-col>
      </b-row>
    </b-card>
  </base-overlay>
</template>

<script>
import { ref, reactive, computed } from '@vue/composition-api'
import {
  BCard, BRow, BCol, BFormDatepicker, BFormInput, BFormGroup, BButton, BSpinner, BFormFile, BAvatar,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { max } from '@/utils/validations'
import StickyDriverData from '../../StickyDriverData.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import documentStoreModule from '@/views/driver/documents/documentStoreModule'
import { errorNotification, successNotification } from '@/utils/toast-notifications'
import DeleteLicenseModal from './components/DeleteLicenseModal.vue'

export default {
  components: {
    BCard, BRow, BCol, vSelect, BFormDatepicker, BFormInput, BFormGroup, BButton, BSpinner, ValidationObserver, ValidationProvider, StickyDriverData, BFormFile, BAvatar, DeleteLicenseModal,
  },
  setup(_, ctx) {
    useRegisterStoreModule('documents', documentStoreModule)
    const file = ref(null)
    const referenceNumber = ref('')
    const licenseData = reactive({
      expiry_date: null,
      effective_date: null,
      reference_number: null,
    })
    const editLicense = ref()
    const validateExpiryMin = computed(() => {
      if (editLicense.value.effective_date) {
        return new Date(`${new Date(editLicense.value.effective_date).getFullYear() + 1}-${new Date(editLicense.value.effective_date).getMonth() + 1}-${new Date(editLicense.value.effective_date).getDate()}`)
      }
      return new Date()
    })
    const validateExpiryMax = computed(() => {
      if (editLicense.value.effective_date) {
        const temp = new Date()
        temp.setFullYear(new Date(editLicense.value.effective_date).getFullYear() + 1)
        temp.setMonth(new Date(editLicense.value.effective_date).getMonth())
        temp.setDate(new Date(editLicense.value.effective_date).getDate() + 3)
        return temp
      }
      return new Date()
    })

    const expiryDateMinimum = computed(() => {
      if (licenseData.effective_date) {
        return new Date(`${new Date(licenseData.effective_date).getFullYear() + 1}-${new Date(licenseData.effective_date).getMonth() + 1}-${new Date(licenseData.effective_date).getDate()}`)
      }
      return new Date()
    })
    const expiryDateMaximum = computed(() => {
      if (licenseData.effective_date) {
        const temp = new Date()
        temp.setFullYear(new Date(licenseData.effective_date).getFullYear() + 1)
        temp.setMonth(new Date(licenseData.effective_date).getMonth())
        temp.setDate(new Date(licenseData.effective_date).getDate() + 3)
        return temp
      }
      return new Date()
    })

    const addLicenseRef = ref(null)
    const editLicenseRef = ref(null)
    const canAddLicense = ref(false)
    const formVisible = ref(false)
    const fetching = ref(false)
    const submitting = ref(false)
    const createprefixNumber = ref('')
    const createsuffixNumber = ref('')
    const prefixNumber = ref(['PSMA', 'USMA', 'SMA', 'MSMA'])
    const licenses = ref([])
    const Dlicenses = ref([])
    const isLicensed = ref(false)
    const fetchLicneses = async () => {
      fetching.value = true
      const result = await ctx.root.$store.dispatch('driverView/fetchDriverLicense', ctx.root.$route.params.id)
      console.log(result)
      if (!result.length) {
        canAddLicense.value = true
        ctx.root.$store.commit('driverView/SET_IS_LICENSED', false)
      } else {
        const licenseTemp = { ...result[0] }
        const now = new Date().getTime()
        const licenseDate = new Date(licenseTemp.expiry_date).getTime()
        if (licenseDate > now) {
          isLicensed.value = true
        } else {
          canAddLicense.value = true
          isLicensed.value = false
        }
        ctx.root.$store.commit('driverView/SET_IS_LICENSED', isLicensed.value)
      }
      const temp = result.map((el, idx) => ({
        ...el,
        openEdit: idx === 0 ? false : undefined,
        editing: false,
      }))
      editLicense.value = { ...temp[0] }
      console.log(editLicense.value)
      if (temp.length > 0) {
        const split = editLicense.value.reference_number.split('_')
        if (split.length > 1) {
          // eslint-disable-next-line prefer-destructuring
          referenceNumber.value = split[0]
          // eslint-disable-next-line prefer-destructuring
          editLicense.value.reference_number = split[1]
        } else if (editLicense.value.reference_number.length > 5) {
          editLicense.value.reference_number = editLicense.value.reference_number.slice(0, 5)
        }
        licenses.value = temp.splice(1)
        fetching.value = false
      }
      fetching.value = false
    }
    const createLicenseHandler = () => {
      formVisible.value = true
      canAddLicense.value = false
    }
    const addLicenseHandler = async () => {
      try {
        submitting.value = true
        const isValid = await addLicenseRef.value.validate()
        if (!isValid) return
        const reference = `${createprefixNumber.value}_${createsuffixNumber.value}`
        licenseData.reference_number = reference
        console.log(licenseData)
        const response = await ctx.root.$store.dispatch('driverView/createLicense', {
          id: ctx.root.$route.params.id,
          licenseData,
        })
        if (file.value) {
          const { url } = response.data.data
          await ctx.root.$store.dispatch('documents/s3Upload', { url, file: file.value })
        }
        await fetchLicneses()
        formVisible.value = false
      } finally {
        submitting.value = false
      }
    }
    const openAttachment = url => window.open(url)

    const handleLicenseEdit = async license => {
      if (license.openEdit) {
        try {
          const isValid = await editLicenseRef.value.validate()
          if (!isValid) return
          // eslint-disable-next-line no-param-reassign
          license.editing = true
          const reference = `${referenceNumber.value}_${license.reference_number}`
          const response = await ctx.root.$store.dispatch('driverView/updateLicense', {
            id: ctx.root.$route.params.id,
            licenseData: {
              id: license.id,
              effective_date: license.effective_date,
              expiry_date: license.expiry_date,
              reference_number: reference,
            },
          })
          if (file.value) {
            const { url } = response.data.data
            await ctx.root.$store.dispatch('documents/s3Upload', { url, file: file.value })
          }
        } catch (error) {
          const message = error?.response?.data?.error?.reference_number[0] || 'Something went wrong'
          errorNotification(message)
        } finally {
        // eslint-disable-next-line no-param-reassign
          license.editing = false
        }
        await fetchLicneses()
      } else {
        // eslint-disable-next-line no-param-reassign
        license.effective_date = null
        // eslint-disable-next-line no-param-reassign
        license.expiry_date = null
        // eslint-disable-next-line no-param-reassign
        license.openEdit = true
      }
    }
    const DeleteLicense = async license => {
      const licenseId = license.id
      await ctx.root.$store.dispatch('driverView/deleteLicense', {
        licenseId,
      })
      successNotification('License deleted successfully')
      await fetchLicneses()
    }
    const openDeleteLicenseModal = license => {
      Dlicenses.value = license
      ctx.root.$bvModal.show('delete-license-modal')
    }
    fetchLicneses()
    return {
      required,
      licenses,
      DeleteLicense,
      openDeleteLicenseModal,
      handleLicenseEdit,
      addLicenseRef,
      file,
      referenceNumber,
      prefixNumber,
      fetchLicneses,
      openAttachment,
      formVisible,
      addLicenseHandler,
      editLicenseRef,
      editLicense,
      max,
      submitting,
      licenseData,
      expiryDateMaximum,
      expiryDateMinimum,
      createLicenseHandler,
      canAddLicense,
      validateExpiryMin,
      validateExpiryMax,
      fetching,
      createprefixNumber,
      createsuffixNumber,
      Dlicenses,
    }
  },
}
</script>

<style>
/* .vs__search{ */
  /* display: none; */
/* } */
.dateField label{
  background-color: red;
  overflow: hidden;
}
.btn-flat-primary:hover:not(.disabled):not(:disabled) {
    background-color: rgb(244 24 24 / 12%);
}
</style>
